import script from "./OrderConfirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderConfirmation.vue?vue&type=script&setup=true&lang=js"

import "./OrderConfirmation.vue?vue&type=style&index=0&id=41c5f4f9&lang=scss&scoped=true"

import exportComponent from "/home/ecs-user/software/jenkins/workspace/smallshop-website-uat/smallshop-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41c5f4f9"]])

export default __exports__